import { Link } from '@tracklib/kit'

type YearProps = {
  year: string | number
}

const Year = ({ year }: YearProps): JSX.Element => (
  <Link to="/tracks" query={{ release_year_after: year, release_year_before: year }}>
    {year}
  </Link>
)

export default Year
